module.exports = __webpack_public_path__ + "img/watage_res_8.223222c5.gif";